import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppProvider } from "./context/AppContext";
import { Layout, ProtectedRoute, AdminRoute } from "./components/Layout";

import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Safety from "./pages/Safety";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Assessment from "./pages/Assessment";
import Payment from "./pages/Payment";
import Report from "./pages/Report";
import Companion from "./pages/Companion";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

const Page = ({ children, bare }) => <Layout bare={bare}>{children}</Layout>;

function App() {
    return (
        <AppProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Page><Home /></Page>} />
                    <Route path="/how-it-works" element={<Page><HowItWorks /></Page>} />
                    <Route path="/about" element={<Page><About /></Page>} />
                    <Route path="/pricing" element={<Page><Pricing /></Page>} />
                    <Route path="/contact" element={<Page><Contact /></Page>} />
                    <Route path="/safety" element={<Page><Safety /></Page>} />
                    <Route path="/privacy" element={<Page><Legal doc="privacy" /></Page>} />
                    <Route path="/terms" element={<Page><Legal doc="terms" /></Page>} />
                    <Route path="/refund" element={<Page><Legal doc="refund" /></Page>} />
                    <Route path="/login" element={<Page><Login /></Page>} />
                    <Route path="/onboarding" element={<Page bare><Onboarding /></Page>} />
                    <Route path="/assessment" element={<ProtectedRoute><Page bare><Assessment /></Page></ProtectedRoute>} />
                    <Route path="/payment" element={<ProtectedRoute><Page><Payment /></Page></ProtectedRoute>} />
                    <Route path="/report" element={<ProtectedRoute><Page><Report /></Page></ProtectedRoute>} />
                    <Route path="/companion" element={<ProtectedRoute><Page bare><Companion /></Page></ProtectedRoute>} />
                    <Route path="/profile" element={<ProtectedRoute><Page><Profile /></Page></ProtectedRoute>} />
                    <Route path="/admin" element={<AdminRoute><Page><Admin /></Page></AdminRoute>} />
                    <Route path="/admin/payments" element={<AdminRoute><Page><Admin tab="payments" /></Page></AdminRoute>} />
                    <Route path="*" element={<Page><Home /></Page>} />
                </Routes>
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </AppProvider>
    );
}

export default App;
